import { ThemeEnum } from '~/enums/Region'

export default defineNuxtPlugin(() => {
  const colorMode = useColorMode()
  const { theme } = useTheme()

  if (theme !== ThemeEnum.SHIPZEE) {
    useLocalStorage('nuxt-color-mode', 'light').value = 'light'
    colorMode.value = 'light'
    colorMode.preference = 'light'
    colorMode.forced = true
  }
})
